module.exports = __webpack_public_path__ + "static/media/ig-color-icon.bc560404.png";